type EventCallback = (data?: RowHoverPayload) => void

class EventBus {
  private events: Map<string, EventCallback[]> = new Map()

  subscribe(event: string, callback: EventCallback): () => void {
    const callbacks = this.events.get(event) ?? []
    if (!this.events.has(event)) {
      this.events.set(event, callbacks)
    }
    callbacks.push(callback)

    return () => {
      const idx = callbacks.indexOf(callback)
      if (idx > -1) {
        callbacks.splice(idx, 1)
      }
    }
  }

  emit(event: string, data?: RowHoverPayload): void {
    this.events.get(event)?.forEach((callback) => callback(data))
  }
}

export const highlightEventBus = new EventBus()

export const HIGHLIGHT_EVENTS = {
  ROW_HOVER: "row:hover",
} as const

export interface RowHoverPayload {
  simulationOutputId: string | null
}
